export default {
  currentStep: 1,
  modalPlanDetails: false,
  customer: null,
  billingInfo: null,
  modalpayment: false,
  componentOpenedInModal: null,
  mount: 0,
  selectPayment: null,
  package: null,
  channel: null,
  quantityPackage: null,
  cartPackges: [],
  showCartNotification: false,
  lastSelectedPackName: '',
  selectedCountry: 'PT',
  iva: 0,
  paymentPeriod: 1,
  setupIntent: null
}
